import { Condition } from "@redotech/redo-model/return-flow/condition";
import { titleCase } from "@redotech/web-util/strings";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type SalesChannelState = readonly string[];

export const SALES_CHANNEL = (
  Details: React.ComponentType<ConditionTypeDetailsProps<SalesChannelState>>,
): ConditionType<SalesChannelState, Condition.SalesChannel> => ({
  name: "Sales channel",
  description(state) {
    const formattedChannels = state.map((string: string) => titleCase(string));
    return `Sales channels: ${formattedChannels.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<SalesChannelState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.SalesChannel) {
    return model.channels;
  },
  toModel(state) {
    return { type: Condition.SALES_CHANNEL, channels: state };
  },
  valid() {
    return true;
  },
});
